import type { InjectionKey, ComputedRef, ShallowRef } from 'vue';
import type { PqvPayloadBasicType } from '~/stores/useProductQuickviewStore';
import type { PqvOptionsBasic } from '@nuxt-common/product-quickview/app/types';

type UseProductQuickViewPdp = {
  isPqvPayloadActive: ComputedRef<boolean>;
  pdpPqvOptions: ShallowRef<PqvOptionsBasic>;
  watchPayloadUpdate: (cb: (payload: PqvPayloadBasicType) => void) => void;
};

// provide / inject key
export const PDP_PRODUCT_QUICKVIEW_REPO: InjectionKey<UseProductQuickViewPdp> = Symbol.for('PDP_PRODUCT_QUICKVIEW_REPO');

// base tagging
export const PDP_PRODUCT_QUICKVIEW_TAGGING: PqvOptionsBasic['tagging'] = {
  onDrawerLoad: {
    quick_view_type: 'wear it with',
  },
  onProductDetailClick: {
    event_name: 'wear it with view full product details',
    link_name: 'wear it with view full product details',
  },
  onAddToBagRequest: {
    bag_add_location: 'wear it with',
  },
};
